import React, { useState } from "react";
import { Info, ChevronDown, ChevronUp } from "lucide-react";

/**
 * DisclaimerFooter — site-wide legal hedge. Renders inside the document flow
 * (NOT fixed). Compact one-liner by default; full text behind an expand toggle
 * so users can read everything without the page feeling buried in legalese.
 */
export default function DisclaimerFooter() {
  const [expanded, setExpanded] = useState(false);
  return (
    <footer
      className="w-full border-t-2"
      style={{
        background: "var(--rm-paper-tint, rgba(15,27,45,0.04))",
        borderColor: "rgba(15,27,45,0.12)",
        marginTop: "24px",
      }}
      data-testid="disclaimer-footer"
    >
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-3">
        <div className="flex items-start gap-2">
          <Info size={12} strokeWidth={2.5} style={{ color: "#94A3B8", marginTop: 3 }} className="flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-[11px] leading-snug" style={{ color: "var(--rm-muted, #475569)" }}>
              AI-generated insights based on the inputs you provide.{" "}
              <strong style={{ color: "var(--rm-ink, #0F1B2D)" }}>
                No guarantees of employment, offers, or salary outcomes.
              </strong>{" "}
              Review outputs before use.{" "}
              <button
                type="button"
                onClick={() => setExpanded((v) => !v)}
                className="font-mono-rm text-[10px] uppercase tracking-widest rm-text-orange inline-flex items-center gap-0.5"
                data-testid="disclaimer-expand-btn"
                style={{ verticalAlign: "baseline" }}
              >
                {expanded
                  ? <>Hide full disclaimer <ChevronUp size={10} /></>
                  : <>Full disclaimer <ChevronDown size={10} /></>}
              </button>
            </p>
            {expanded && (
              <p
                className="text-[11px] leading-relaxed mt-2 pt-2"
                style={{
                  color: "var(--rm-muted, #475569)",
                  borderTop: "1px dashed rgba(15,27,45,0.18)",
                }}
                data-testid="disclaimer-full-text"
              >
                Resmo is a career-intelligence companion that produces AI-generated
                insights, resume edits, salary ranges, role research, and interview
                prompts based on public market data and the inputs you provide.
                Outputs may contain errors, omissions, or out-of-date information
                and should be reviewed by you before use. Resmo is not a substitute
                for professional legal, financial, recruiting, or career-counseling
                advice. Your job search outcomes depend on many factors outside our
                control, including market conditions, employer decisions, and your
                own engagement with the search process. Use of Resmo is at your
                own discretion.
              </p>
            )}
            <div
              className="font-mono-rm text-[10px] uppercase tracking-widest mt-1.5"
              style={{ color: "var(--rm-muted-strong, #94A3B8)" }}
            >
              © {new Date().getFullYear()} Resmo · Career intelligence companion · Private beta
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
